import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MydiaryService } from 'src/app/services/mydiary.service';
import { DiaryRedendDialgComponent } from '../diary-redend-dialg/diary-redend-dialg.component';
import { ResendDialogComponent } from '../resend-dialog/resend-dialog.component';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-pending-approval',
  templateUrl: './my-pending-approval.component.html',
  styleUrls: ['./my-pending-approval.component.css'],
})
export class MyPendingApprovalComponent implements OnInit {
  pendingDiaryApprovalList: any;
  pendingDiaryApprovalDetails: any;
  showDiaryApprovalDetails = false;
  selectedEmployee: any;
  approverList: any;
  pendingLeaveApprovalList: any;
  leaveApprovalDetails: any;
  appliedLeavesList: any;
  showLeaveApprovalDetails = false;
  selectedEmployeeForLeave: any;

  constructor(
    public dialog: MatDialog,
    private mydiaryService: MydiaryService,
    private commonMessageService:CommonMessageService
  ) {}

  ngOnInit(): void {
    this.loadPendingDiaryApproval();
    //this.loadApproversList();
  }
  msg: string;

  openDialogDiaryResend(approvalDetails): void {
    const dialogRef = this.dialog.open(DiaryRedendDialgComponent, {
      width: '700px',
      data: { msg: this.msg },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      this.msg = result;
      console.log(' this.msg', this.msg);
      if (this.msg != null) {
        this.resendDiary(approvalDetails, this.msg);
        this.msg = '';
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ResendDialogComponent, {
      width: '700px',
      data: { msg: this.msg },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      this.msg = result;
      console.log(' this.msg', this.msg);
      if (this.msg != null) {
        this.resendMsgLeave('Resend', this.msg);
        this.msg = '';
      }
    });
  }

  loadPendingDiaryApproval() {
    this.mydiaryService.getPendingDiaryApprovals().subscribe((res) => {
      console.log('pendingDiaryApprovalList', res);
      this.pendingDiaryApprovalList = res;
      this.loadPendingLeaveApproval();
    });
  }

  viewDiaryDetails(approval) {
    console.log(approval);
    this.selectedEmployee = approval;
    this.mydiaryService
      .getPendingDiaryApprovalDetails(
        approval.employeeId,
        approval.weekStartDate,
        approval.weekEndDate
      )
      .subscribe((res) => {
        console.log(res);
        this.pendingDiaryApprovalDetails = res;
        console.log('pending approval list', this.pendingDiaryApprovalDetails);
        this.showDiaryApprovalDetails = true;
      });
  }

  approveDiary(approval) {
    this.mydiaryService.approveDiary(approval.id).subscribe((res) => {
      console.log(res);
      this.commonMessageService.swalAlertWithIcon('','Approved Successfully!','success');
      this.viewDiaryDetails(this.selectedEmployee);
    });
  }

  resendDiary(approval, msg) {
    this.mydiaryService.resendDiary(approval.id, msg).subscribe((res) => {
      console.log(res);
      this.commonMessageService.swalAlertWithIcon('','Resend Successfully!','success');
      this.viewDiaryDetails(this.selectedEmployee);
    });
  }

  approveAllDiary() {
    this.mydiaryService
      .approveAllDiary(this.selectedEmployee)
      .subscribe((res) => {
        console.log(res);
          this.commonMessageService.swalAlertWithIcon('','Approved Successfully!','success');
        this.resetScreen();
        // this.viewDiaryDetails(this.selectedEmployee);
      });
  }

  loadPendingLeaveApproval() {
    this.mydiaryService.getPendingLeaves().subscribe((res) => {
      console.log('approval response', res);
      this.pendingLeaveApprovalList = res;
    });
  }

  viewLeaveDetails(leaveObj) {
    console.log(leaveObj);
    this.selectedEmployeeForLeave = leaveObj;
    this.mydiaryService.getPendingLeaveDetail(leaveObj.id).subscribe((res) => {
      console.log(res);
      this.leaveApprovalDetails = res;
      this.loadAppliedLeavesForUser(leaveObj);
    });
  }

  loadAppliedLeavesForUser(leaveObj) {
    this.mydiaryService
      .getAppliedLeavesForUser(leaveObj.user.id)
      .subscribe((res) => {
        console.log(res);
        this.appliedLeavesList = res;
        this.showLeaveApprovalDetails = true;
      });
  }

  changeLeaveStatus(status) {
    if (status == 'Approved') {
      this.approveLeave(status);
    } else {
      // this.resendMsgLeave(status);
    }
  }

  resendMsgLeave(status, msg) {
    this.mydiaryService
      .changeLeaveStatusMsg(this.selectedEmployeeForLeave.id, status, msg)
      .subscribe((res) => {
        console.log(res);
          this.commonMessageService.swalAlertWithIcon('','Resent Successfully!','success');
        this.resetScreen();
      });
  }

  approveLeave(status) {
    this.mydiaryService
      .changeLeaveStatus(this.selectedEmployeeForLeave.id, status)
      .subscribe((res) => {
        console.log(res);
          this.commonMessageService.swalAlertWithIcon('','Approved Successfully!','success');
        this.resetScreen();
      });
  }

  resendLeave(status) {
    this.mydiaryService
      .changeLeaveStatus(this.selectedEmployeeForLeave.id, status)
      .subscribe((res) => {
        console.log(res);
       this.commonMessageService.swalAlertWithIcon('','Approved Successfully!','success');
        this.resetScreen();
      });
  }

  resetScreen() {
    this.showDiaryApprovalDetails = false;
    this.showLeaveApprovalDetails = false;
    this.ngOnInit();
  }

  // loadApproversList(){
  //   this.mydiaryService.getApprovers()
  //   .subscribe(res => {
  //     console.log(res);
  //     this.approverList = res;
  //     //this.loadLeaveType();
  //   });
  // }
}
